module.exports = __webpack_public_path__ + "img/173.1434e353.png";